import React from "react";
import * as RequisitionTypes from "../../../general/paper-state";

const CHIP_CLASS = {
  [RequisitionTypes.DRAFT]: "ds-chip--draft",
  [RequisitionTypes.WAITING_APPROVAL]: "ds-chip--pending",
  [RequisitionTypes.APPROVED]: "ds-chip--approved",
  [RequisitionTypes.REJECTED]: "ds-chip--rejected",
};

export default function PaperStateChip({ state }) {
  const variant = CHIP_CLASS[state] || "ds-chip--pending";
  return (
    <span className={`ds-chip ${variant}`}>
      {RequisitionTypes.getTypeForId(state)}
    </span>
  );
}
